// extracted by mini-css-extract-plugin
export default {"remainingReactionsPopover":"d8aakpk6Nj4Al6ziqMrg","reactions":"MrCm2HgmKGTs4xFmDJ_j"};